module.exports = __webpack_public_path__ + "img/bullet_right.8cccbe30.svg";